/** Utility: format currency */
export const fmtMoney = (n, currency = "USD") =>
    new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 2 }).format(Number(n || 0));

/** Utility: short date */
export const fmtDate = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch { return "—"; }
};

export const fmtDateTime = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
    } catch { return "—"; }
};

export const titleCase = (s) =>
    (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const statusToneMap = {
    active: "success", paid: "success", completed: "success", delivered: "success",
    pending: "warning", scheduled: "warning", open: "warning", planned: "warning", in_progress: "warning",
    overdue: "destructive", cancelled: "destructive", failed: "destructive", missed: "destructive",
    paused: "muted", void: "muted", in_route: "info", submitted: "info",
};
